import { useGetAdminGroupsQuery, useGetProductsQuery } from '../api/group/groupAdminApiSlice';
import { useTenantProductCategoriesQuery } from './useTenantProductCategoriesQuery';
import { EventTypeInput, resolveEventTypeInputForGroup } from '../utils/eventTypeInput';

/**
 * The event input mode for the room a booking screen has selected, read from
 * the admin group, product and category lists (cached, tenant-keyed slices).
 *
 * `failed` is set when any of the three reads failed. The caller must not
 * treat that as "this room uses the dropdown": a failure never looks like an
 * absence (CLAUDE.md), so `EventTypeField` then says so and lets staff type.
 */
export const useEventTypeInput = (
    groupId: string | null | undefined,
): { mode: EventTypeInput, failed: boolean } => {
    const skip = !groupId;
    const groups = useGetAdminGroupsQuery(undefined, { skip });
    const products = useGetProductsQuery(undefined, { skip });
    const categories = useTenantProductCategoriesQuery(undefined, { skip });
    return {
        mode: resolveEventTypeInputForGroup(groupId, groups.data, products.data, categories.data),
        failed: !skip && (groups.isError || products.isError || categories.isError),
    };
};

export default useEventTypeInput;
